// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__30lcz","right":"Footer_right__12bYz","buttons":"Footer_buttons__2OsjD"};